import type { Project } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getBySupervisorBySupervisorId = (supervisorId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Project[]>({
      method: 'GET',
      url: `/api/app/project/by-supervisor/${supervisorId}`,
    },
    { apiName: this.apiName,...config });
  

  getByVendorByVendorId = (vendorId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Project[]>({
      method: 'GET',
      url: `/api/app/project/by-vendor/${vendorId}`,
    },
    { apiName: this.apiName,...config });
}